<strong class="title">{{ 'gearInfo.title' | translate }}</strong>
<div *ngIf="gear?.gear as info" class="info">
  <div>
    <strong>{{ 'gearInfo.name' | translate }}</strong>
    <span>{{ info.name }}</span>
  </div>
  <div>
    <strong>{{ 'gearInfo.author' | translate }}</strong>
    <span>{{ info.author }}</span>
  </div>
  <div>
    <strong>{{ 'gearInfo.maintainer' | translate }}</strong>
    <span>{{ info.maintainer }}</span>
  </div>
  <div>
    <strong>{{ 'gearInfo.version' | translate }}</strong>
    <span>{{ info.version }}</span>
  </div>
  <div>
    <strong>{{ 'gearInfo.source' | translate }}</strong>
    <a [href]="info.source | trusturl" target="_blank">{{ info.source }}</a>
  </div>
  <div>
    <strong>{{ 'gearInfo.url' | translate }}</strong>
    <a [href]="info.url | trusturl" target="_blank">{{ info.url }}</a>
  </div>
  <div>
    <strong>{{ 'gearInfo.license' | translate }}</strong>
    <span>{{ info.license }}</span>
  </div>
</div>
